<template>
  <div class="addInfor">
    <van-popup v-model="show" class="tishiTanchu">
      <div class="tishiContent">
        <div class="chaIcon" @click="noShowTishi">
          <img src="../assets/images/chaIcon.png" alt="" />
        </div>

        <div class="midImg">
          <img src="../assets/images/successSub.png" alt="" />
        </div>
        <div class="dibuBtn">
          <button @click="noShowTishi">好的，知道了</button>
        </div>
      </div>
    </van-popup>
    <div class="shuru">
      <div class="titleShuru">
        <input
          type="text"
          placeholder="标题"
          v-model="infor.title"
          maxlength="20"
        />
      </div>
      <div class="contentArea">
        <textarea
          id="a"
          v-model="infor.content"
          maxlength="250"
          placeholder="内容"
        ></textarea>
        <div class="wordLimit">{{ infor.content.length }}/250</div>
      </div>
    </div>
    <div class="dibubtn" @click="changeInfor">
      <button>确定修改</button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { doRem } from "../utils/setrem";
import { Field } from "vant";
import { Dialog } from "vant";
import qs from "qs";

// 全局注册
Vue.use(Dialog);

Vue.use(Field);
export default {
  mounted() {

    this.getInfor();
    // this.getToken()
  },
  data() {
    return {
      inforText: "",
      areaLength: "0",
      inforTitle: "",
      show: false,
      infor: {
        content: "",
        createtime: Number,
        id: "",
        title: "",
        userid: "",
      },
    };
  },
  methods: {
    noShowTishi() {
      this.$router.push("CommonInfor");
    },
    // limitLength() {
    //   this.areaLength = this.infor.content.length;
    // },
    changeInfor() {
      let params = qs.stringify({
        title: this.infor.title,
        content: this.infor.content,
        id: this.infor.id,
      });
      this.$axios
        .post("cityuserinfo/commonly/info/updUserCommonlyInfo", params)
        .then((res) => {
          if (res.data.result !== 1) {
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            this.show = true;
            this.infor.title = "";
            this.infor.content = "";

            return;
          }
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    getInfor() {
      let params = qs.stringify({
        id: this.$route.query.id,
      });
      this.$axios
        .post("cityuserinfo/commonly/info/getBean", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            this.infor.content = res.data.bean.content;
            this.infor.createtime = res.data.bean.createtime;
            this.infor.id = res.data.bean.id;
            this.infor.title = res.data.bean.title;
            this.infor.userid = res.data.bean.userid;
          }
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
  },
};
</script>


<style lang="scss" scoped>
.addInfor {
  background: #eef4f6;
  min-height: 100vh;
  padding: 1.25rem 2rem 0 2rem;
}
.shuru {
  background-color: #fff;
  border-radius: 1rem;
  .titleShuru {
    padding: 2.5rem 2.25rem;
    border-bottom: 1px solid #eaeaea;
    input {
      width: 100%;
      border: none;
      font-size: 1.875rem;
      color: #19212a;
    }
  }
  .contentArea {
    padding: 2.25rem 2.25rem 1.5rem 2.25rem;
    #a {
      width: 100%;
      height: 25rem;
      border: none;
      font-size: 1.875rem;
      color: #19212a;
    }
    .wordLimit {
      text-align: right;
      color: #878787;
      font-size: 1.75rem;
    }
  }
}
.dibubtn {
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3.25rem;

  button {
    width: 100%;
    height: 5.5rem;
    background: linear-gradient(90deg, #19a0a0 0%, #0f7876 100%);
    border: none;
    color: #ffffff;
    font-size: 2rem;
    border-radius: 2.75rem;
    line-height: 5.5rem;
  }
}
.tishiTanchu {
  width: 90%;
  border-radius: 1.875rem;
  .tishiContent {
    position: relative;
    padding: 2.375rem 2.625rem 3.375rem 2.625rem;
    .chaIcon {
      position: absolute;
      right: 2.625rem;
      top: 2.625rem;
      img {
        width: 1.625rem;
        height: 1.625rem;
      }
    }
    .midImg {
      display: flex;
      justify-content: center;
      img {
        width: 16.375rem;
        height: 18.125rem;
      }
    }
    .thirdWord {
      text-align: center;
      color: #19212a;
      font-size: 2rem;
      line-height: 3.5rem;
    }
    .dibuBtn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 2.375rem;
      button {
        padding: 1.125rem 6.125rem;
        white-space: nowrap;
        background: linear-gradient(90deg, #19a0a0 0%, #0f7876 100%);
        color: #ffffff;
        font-size: 2rem;
        line-height: 2.875rem;
        border: none;
        border-radius: 2.5rem;
        font-weight: 900;
      }
    }
  }
}
</style>